/* This example requires Tailwind CSS v2.0+ */
import React from 'react';

import {
  Section,
  Container,
  Grid,
  Col,
  Flex,
  SectionHeader,
  SanityBlockContent,
} from '../../common';
import { useResponsiveInViewConfigMargin } from '../../../hooks';
import { GatsbyImage } from 'gatsby-plugin-image';

const CaseStudies = ({ page, sanity, section }) => {
  const { colors, caseStudies } = sanity;
  const { header, createList, autoList, displayHeader } = section;
  const inViewConfigMargin = useResponsiveInViewConfigMargin();

  const autoListTitles = autoList?.map((tag) => tag.title);
  const filteredCaseStudies = autoList
    ? caseStudies.filter((caseStudy) =>
        caseStudy?.tags?.some((tag) => autoListTitles?.includes(tag?.title))
      )
    : createList;

  return (
    <Section
      idName="case-studies"
      padding="lg"
      bgColor={colors?.neutral?.white}
      h2Color={colors?.neutral?.darker}
    >
      <Container
        padding="none"
        classes="max-w-md px-4 lg:px-0 text-center sm:max-w-3xl lg:max-w-7xl"
        inViewConfigMargin={inViewConfigMargin}
      >
        <Grid classes="gap-24">
          {filteredCaseStudies
            ?.sort((a, b) => (a?.title || '').localeCompare(b?.title || ''))
            ?.map((caseStudy, index) => (
              <Col
                padding="1rem"
                classes="space-y-4 border border-1 rounded-xl shadow-xl"
              >
                <Grid classes="lg:grid-cols-12 gap-8">
                  <Col classes="lg:col-span-2">
                    <GatsbyImage
                      image={caseStudy?.image.asset?.gatsbyImageData}
                      alt={caseStudy?.image?.alt}
                      className="h-full w-full rounded-xl object-cover shadow-xl"
                    />
                  </Col>
                  <Col classes="lg:col-span-10 text-left space space-y-4">
                    {/* <p className="w-fit rounded-full bg-gray-800 px-3 py-1 text-base text-gray-500 sm:mt-4">
                    {caseStudy?.tags?.map((tag) => tag.title).join(', ')}
                  </p> */}
                    <div className="space-y-2">
                      <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                        {caseStudy?.title}
                      </h2>
                      <p className="text-xl">
                        <span className="font-bold">Location: </span>
                        {caseStudy?.location}
                      </p>
                      <SanityBlockContent
                        sanity={sanity}
                        blocks={caseStudy?._rawDescription}
                        classes="italic text-lg"
                      />
                    </div>
                  </Col>
                </Grid>
                <Grid classes="lg:grid-cols-12 gap-8 text-white text-left">
                  <Col
                    isBgColor={true}
                    padding="2rem"
                    bgColor={colors?.neutral?.default}
                    classes="lg:col-span-4 space-y-2"
                  >
                    <h3 className="!text-red-500">Problems</h3>
                    <SanityBlockContent
                      sanity={sanity}
                      blocks={caseStudy?._rawProblem}
                    />
                  </Col>
                  <Col
                    isBgColor={true}
                    padding="2rem"
                    bgColor={colors?.primary?.default}
                    classes="lg:col-span-8 space-y-2"
                  >
                    <h3 className="!text-green-500">Solutions</h3>
                    <SanityBlockContent
                      sanity={sanity}
                      blocks={caseStudy?._rawSolution}
                    />
                  </Col>
                </Grid>
              </Col>
            ))}
        </Grid>
      </Container>
    </Section>
  );
};

export { CaseStudies };
